import React from "react";
import "../styles/clientSection.css";
import batasLogo from "../images/batasMAW.png";
import imeGroupLogo from "../images/IMEGroup.png";
import imeMotors from "../images/IMEMotors.png"
import NDPL from "../images/NDPL.png"
import KTS from "../images/kathmanduTSchool.png"
import omniMotors from "../images/omniMotors.png"
import NorvicHospital from "../images/norvicHospital.png"
import AshokLeyland from "../images/AshokLeyland.png"
import EicherMotors from "../images/Eicher.png"
import Bharatbenz from "../images/bharatbenz.png"
import TriveniMotors from "../images/tribeniMotorCorp.png"
import VentureHire from "../images/ventureHire.png"


// Import Slick
import Slider from "react-slick"; // React Slick Component

// Slick Styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ClientSection = () => {
  const clients = [
    { id: 1, name: "IME Group", logo: imeGroupLogo },
    { id: 2, name: "IME Motors", logo: imeMotors },
    { id: 3, name: "Nepal Development Public Limited(NDPL)", logo: NDPL },
    { id: 4, name: "Batas MAW", logo: batasLogo },
    { id: 5, name: "Kathmandu Technical School", logo: KTS },
    { id: 6, name: "Omni Motors", logo: omniMotors },
    { id: 7, name: "Norvic Hospital", logo: NorvicHospital },
    { id: 8, name: "Ashok Leyland", logo: AshokLeyland },
    { id: 9, name: "Eicher Motors", logo: EicherMotors },
    { id: 10, name: "Bharatbenz Motors", logo: Bharatbenz },
    { id: 11, name: "Triveni Motocorporation", logo: TriveniMotors },
    { id: 11, name: "Venture Hire Purchase", logo: VentureHire },
  ];

  // Slick Carousel settings
  const settings = {
    infinite: true,  
    speed: 500,      
    slidesToShow: 7, 
    slidesToScroll: 1, 
    arrows: true,    
    autoplay: true, 
    autoplaySpeed: 1000, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3, // Show 3 slides on medium screens
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // Show 2 slides on tablets
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2, // Show 1 slide on small screens
        },
      },
    ],
  };

  return (
    <div className="client-section">
      <h2 className="section-title">Our Clients</h2>

      {/* Slick Carousel */}
      <Slider {...settings} className="client-slider">
        {clients.map((client) => (
          <div key={client.id} className="client-card">
            <img
              src={client.logo}
              alt={`${client.name} Logo`}
              className="client-logo"
            />
            <p className="client-name">{client.name}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ClientSection;
